import React from 'react';
import type { Testimonio } from '../data/content';
type TestimonialCardProps = {
  testimonio: Testimonio;
};
export function TestimonialCard({
  testimonio
}: TestimonialCardProps) {
  return <figure className="flex h-full flex-col justify-between rounded-3xl border border-ink-line bg-ink-card p-6 sm:p-7" data-id="element-165" data-mp="2kggc2lhytwki">
      <div data-id="element-166" data-mp="2p8q7ui5rhqup">
        <p className="text-sm tracking-widest text-oro" aria-label="5 de 5 estrellas" data-id="element-167" data-mp="2p8hsmjm629gc">
          ⭐⭐⭐⭐⭐
        </p>
        <blockquote className="mt-4 font-display text-lg leading-snug text-violeta-50" data-id="element-168" data-mp="2u6jflfmpqsx3">
          “{testimonio.quote}”
        </blockquote>
      </div>
      <figcaption className="mt-6 flex items-center gap-3" data-id="element-169" data-mp="344fpk43wzhtm">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-violeta-600/25 font-display text-xs font-bold text-violeta-200" data-id="element-170" data-mp="342uveflii0wa">
          {testimonio.initials}
        </span>
        <span className="text-sm" data-id="element-171" data-mp="19tapf9s1dnj1">
          <span className="block font-semibold text-white" data-id="element-172" data-mp="1drrkguy6n7k3">{testimonio.name}</span>
          <span className="block text-violeta-300/80" data-id="element-173" data-mp="hskrqu43vo67">{testimonio.place}</span>
        </span>
      </figcaption>
    </figure>;
}